// Utils for parsing followup entities: editorState->markdown and markdown->editorState
const FOLLOWUP_REGEX = /^\[followup:(.[^\]]+)\]/;

export const markdownToDraftFollowupEntityRules = {
  followup_open: (entity) => ({ type: 'followup', mutability: 'IMMUTABLE', data: entity.data }),
};

export const draftFollowupsToMarkdownRules = {
  followup: {
    open: () => `[followup:`,
    close: () => ']',
  },
};

export const createFollowupRemarkablePlugin = (md) => {
  md.inline.ruler.push('followup', (state): boolean => {
    const marker = state.src[state.pos];

    if (marker == '[') {
      const match = FOLLOWUP_REGEX.exec(state.src.slice(state.pos));

      if (match) {
        const [fullMatch, text] = match;
        const content = text;
        const length = fullMatch.length;

        state.push({
          type: 'followup_open',
          level: state.level,
          data: { text },
        });
        state.push({ type: 'text', content, level: state.level + 1 });
        state.push({ type: 'followup_close', level: state.level });

        state.pos += length;
        return true;
      }
    }

    return false;
  });
};
